module.exports = __webpack_public_path__ + "static/media/investor7.884216f3.svg";